import { createContext } from 'react';

const ContextoAgenda = createContext(undefined);

export default ContextoAgenda;
